import styled, { css } from 'styled-components';

export const DomainsAlertsWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    margin-bottom: 16px;
    padding: 16px;

    a {
      font-size: inherit;
    }
  `}
`;
